module.exports = __webpack_public_path__ + "producr-dried fresh-grass-18.jpg?13801de52bbc9cda6edb58168d41c2f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-18.jpg
// module id = 76
// module chunks = 0